//noinspection JSUnusedGlobalSymbols

/**
 * ESA Component: Site Script
 * -------------------------------------------------------------
 * @copyright {{PKG_COPYRIGHT}}
 * @license   {{PKG_LICENSE}}
 * @version   {{PKG_VERSION}}, {{PKG_DATE}}
 */

import AddressController from "./sources/AddressController.js";
import ClientController from "./sources/ClientControllerSite.js";
import EventController from "./sources/EventControllerSite.js";
import EventsController from "./sources/EventsController.js";
import LiveEventController from "./sources/LiveEventController.js";
import OnDemandEventController from "./sources/OnDemandEventController.js";
import PaymentController from "./sources/PaymentController.js";
import RegisterController from "./sources/RegisterController.js";
import {View} from "./sources/View.js";
// import styles
import '../scss/com_esa.site.scss';

//noinspection JSUnresolvedReference
console.log('{{PKG_NAME}}', '{{PKG_VERSION}}', '{{PKG_DATE}}');

// Set available controllers
const controllers = [
  AddressController,
  ClientController,
  EventController,
  EventsController,
  LiveEventController,
  OnDemandEventController,
  PaymentController,
  RegisterController
];

window.EsaContainer = window.EsaContainer || {};
const ComponentView = window.EsaContainer.View || new View(controllers);
window.EsaContainer.View = ComponentView;

document.addEventListener("DOMContentLoaded", event => ComponentView.onLoad(event));
document.addEventListener("joomla:updated", event => ComponentView.onUpdate(event));
